import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n        bottom: 15px;\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n        top: 15px;\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n        right: 15px;\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n        left: 15px;\n      "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n        transform: rotate(225deg);\n      "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n        transform: rotate(135deg);\n      "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n        transform: rotate(315deg);\n      "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n        transform: rotate(45deg);\n      "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
import styled from "@emotion/styled";
import { darken } from "polished";
import { css } from "@emotion/react";
import { mq } from "../../Theme";
import { IconButton } from "../IconButton";
var HUIPopoverWrapper = /*#__PURE__*/ styled("div", {
    target: "esso4kj0"
})("position:relative;z-index:20;width:100%;&:hover{/* make sure other popovers are beneath the current one */\n    z-index:30;}& > div[data-headlessui-state]{/* make sure the content box does not get larger then expected */\n    display:flex;}/** @TODO:Add transition using https://headlessui.com/react/transition */");
var PanelWrapper = /*#__PURE__*/ styled("div", {
    target: "esso4kj1"
})("margin:1.5rem;border-color:", function(param) {
    var theme = param.theme;
    return darken(0.01, theme.color.natural10);
}, ";border-radius:", function(param) {
    var theme = param.theme;
    return theme.borderRadius.md;
}, ";border-width:3px;border-style:solid;background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";box-shadow:0 0 rgb(0 0 0 / 0%),0 0 rgb(0 0 0 / 0%),", function(param) {
    var theme = param.theme;
    return theme.boxShadow.lg;
}, ";");
var PanelContentWrapper = /*#__PURE__*/ styled("div", {
    target: "esso4kj2"
})("position:relative;z-index:10;overflow:hidden;border-radius:0.75rem;background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";width:", function(param) {
    var width = param.width;
    return width && width;
}, ";padding:", function(param) {
    var padding = param.padding;
    return padding && padding;
}, ";", mq("sm"), "{width:", function(param) {
    var widthMd = param.widthMd;
    return widthMd && widthMd;
}, ";}");
var ArrowPositioner = /*#__PURE__*/ styled("div", {
    target: "esso4kj3"
})(function(param) {
    var position = param.position;
    if (position === "top") {
        return css(_templateObject());
    }
    if (position === "bottom") {
        return css(_templateObject1());
    }
    if (position === "left") {
        return css(_templateObject2());
    }
    if (position === "right") {
        return css(_templateObject3());
    }
    return "";
});
var Arrow = /*#__PURE__*/ styled("div", {
    target: "esso4kj4"
})("height:1.5rem;width:1.5rem;border-width:3px;border-top-style:solid;border-left-style:solid;border-color:", function(param) {
    var theme = param.theme;
    return darken(0.01, theme.color.natural10);
}, ";background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";box-shadow:0 0 rgb(0 0 0 / 0%),0 0 rgb(0 0 0 / 0%),0 6px 20px rgb(0 0 0 / 6%);clip-path:polygon(125% 0,0 0,0 125%);", function(param) {
    var position = param.position;
    if (position === "top") {
        return css(_templateObject4());
    }
    if (position === "left") {
        return css(_templateObject5());
    }
    if (position === "right") {
        return css(_templateObject6());
    }
    if (position === "bottom") {
        return css(_templateObject7());
    }
    return "";
});
var CloseButton = /*#__PURE__*/ styled(IconButton, {
    target: "esso4kj5"
})("color:", function(param) {
    var theme = param.theme;
    return theme.color.natural100;
}, ";position:absolute;z-index:30;/* calculate 2x parent margin */\n  right:", function(param) {
    var theme = param.theme;
    return "calc(2*".concat(theme.spacing[50], ")");
}, ";top:", function(param) {
    var theme = param.theme;
    return "calc(2*".concat(theme.spacing[50], ")");
}, ";");
export { Arrow, ArrowPositioner, CloseButton, HUIPopoverWrapper, PanelWrapper, PanelContentWrapper };
